var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var choices = require('../../libs/choices');
var equipmentModel = require('../../equipment/models/equipment');
var Point = require('../../data/models/point');
var classPointSelection = require('../../dashboards/utils/classPointSelection');

var MAX_POINTS_PER_ADD = 5000;
var bulkAddPointsModal = {};

bulkAddPointsModal.classOptions = prop([]);
bulkAddPointsModal.selectedClasses = prop([]);
bulkAddPointsModal.discoveredDatasets = prop([]);
bulkAddPointsModal.equipmentOptions = prop([]);
bulkAddPointsModal.equipmentScope = prop('all');
bulkAddPointsModal.selectedEquipment = prop([]);
bulkAddPointsModal.pointGroups = prop([]);
bulkAddPointsModal.selectedPointGroups = prop([]);
bulkAddPointsModal.loadingClasses = prop(false);
bulkAddPointsModal.loadingPoints = prop(false);
bulkAddPointsModal.error = prop('');
bulkAddPointsModal._discoveryRequest = 0;
bulkAddPointsModal._pendingSelection = null;

function normalizeLocationRid(reportRecord) {
  return classPointSelection.normalizeRid(reportRecord && reportRecord.locationRid);
}

function selectedClassChoices(values) {
  if (arguments.length === 0) return (bulkAddPointsModal.selectedClasses() || []).slice();
  var normalized = Array.from(new Set((Array.isArray(values) ? values : [values])
    .filter(Boolean)
    .map(String)));
  bulkAddPointsModal._discoveryRequest += 1;
  bulkAddPointsModal._pendingSelection = null;
  bulkAddPointsModal.selectedClasses(normalized);
  bulkAddPointsModal.discoveredDatasets([]);
  bulkAddPointsModal.equipmentOptions([]);
  bulkAddPointsModal.selectedEquipment([]);
  bulkAddPointsModal.selectedPointGroups([]);
  bulkAddPointsModal.pointGroups([]);
  bulkAddPointsModal.loadingPoints(false);
  bulkAddPointsModal.error('');
  if (normalized.length) loadPointsForClasses();
  return normalized;
}

function getActiveEquipmentOptions() {
  var allEquipment = bulkAddPointsModal.equipmentOptions() || [];
  if (bulkAddPointsModal.equipmentScope() !== 'selected') return allEquipment.slice();
  var selected = new Set((bulkAddPointsModal.selectedEquipment() || [])
    .map(classPointSelection.normalizeRid)
    .filter(Boolean));
  return allEquipment.filter(function (option) {
    return selected.has(classPointSelection.normalizeRid(option.value));
  });
}

function refreshPointGroups(desiredPointGroups) {
  var equipment = getActiveEquipmentOptions();
  if (!equipment.length) {
    bulkAddPointsModal.pointGroups([]);
    return;
  }
  var equipmentRids = equipment.map(function (option) { return option.value; });
  var datasets = classPointSelection.filterDatasetsByEquipment(
    bulkAddPointsModal.discoveredDatasets(),
    equipmentRids
  );
  var groups = classPointSelection.buildPointGroups(datasets, equipment);
  var available = new Set(groups.map(function (group) { return group.value; }));
  var desired = Array.isArray(desiredPointGroups)
    ? desiredPointGroups
    : (bulkAddPointsModal.selectedPointGroups() || []);
  bulkAddPointsModal.pointGroups(groups);
  bulkAddPointsModal.selectedPointGroups(desired.filter(function (value) {
    return available.has(value);
  }));
}

function selectedEquipmentChoices(values) {
  if (arguments.length === 0) return (bulkAddPointsModal.selectedEquipment() || []).slice();
  var normalized = Array.from(new Set((Array.isArray(values) ? values : [values])
    .map(classPointSelection.normalizeRid)
    .filter(Boolean)));
  bulkAddPointsModal.selectedEquipment(normalized);
  refreshPointGroups();
  return normalized;
}

function selectEquipmentScope(value) {
  var normalized = value === 'selected' ? 'selected' : 'all';
  if (bulkAddPointsModal.equipmentScope() === normalized) return;
  bulkAddPointsModal.equipmentScope(normalized);
  refreshPointGroups();
}

function selectedPointChoices(values) {
  if (arguments.length === 0) return (bulkAddPointsModal.selectedPointGroups() || []).slice();
  var normalized = Array.from(new Set((Array.isArray(values) ? values : [values])
    .filter(Boolean)
    .map(String)));
  bulkAddPointsModal.selectedPointGroups(normalized);
  return normalized;
}

function loadClassOptions() {
  bulkAddPointsModal.loadingClasses(true);
  return Promise.resolve(equipmentModel.getClassTree())
  .then(function (tree) {
    bulkAddPointsModal.classOptions(classPointSelection.buildClassOptions(tree));
  })
  .catch(function (error) {
    bulkAddPointsModal.classOptions([]);
    bulkAddPointsModal.error(error && error.message ? error.message : 'Unable to load equipment classes.');
  })
  .finally(function () {
    bulkAddPointsModal.loadingClasses(false);
    m.redraw();
  });
}

function loadPointsForClasses() {
  var locationRid = normalizeLocationRid(bulkAddPointsModal.reportRecord);
  var selectedClasses = bulkAddPointsModal.selectedClasses() || [];
  if (!locationRid || !selectedClasses.length) return Promise.resolve();
  var requestId = ++bulkAddPointsModal._discoveryRequest;
  bulkAddPointsModal.loadingPoints(true);
  bulkAddPointsModal.error('');
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/entities/field-discovery',
    method: 'GET',
    background: true,
    params: {
      locationRid: locationRid.replace(/^#/, ''),
      equipmentClasses: selectedClasses.join(','),
      componentDepthLimit: 1,
      summaryOnly: 0
    }
  })
  .then(function (fieldDiscovery) {
    if (requestId !== bulkAddPointsModal._discoveryRequest) return;
    var datasets = classPointSelection.normalizeFieldDiscovery(fieldDiscovery, Point.formatUnit);
    var equipmentOptions = classPointSelection.buildEquipmentOptions(fieldDiscovery);
    var pending = bulkAddPointsModal._pendingSelection;
    bulkAddPointsModal.discoveredDatasets(datasets);
    bulkAddPointsModal.equipmentOptions(equipmentOptions);
    if (pending) {
      var availableEquipment = new Set(equipmentOptions.map(function (option) { return option.value; }));
      bulkAddPointsModal.equipmentScope(pending.equipmentScope === 'selected' ? 'selected' : 'all');
      bulkAddPointsModal.selectedEquipment((pending.selectedEquipmentRids || []).map(classPointSelection.normalizeRid).filter(function (rid) {
        return rid && availableEquipment.has(rid);
      }));
      refreshPointGroups(pending.pointDefinitions || []);
      bulkAddPointsModal._pendingSelection = null;
    } else {
      refreshPointGroups();
    }
  })
  .catch(function (error) {
    if (requestId !== bulkAddPointsModal._discoveryRequest) return;
    bulkAddPointsModal.pointGroups([]);
    bulkAddPointsModal.discoveredDatasets([]);
    bulkAddPointsModal.equipmentOptions([]);
    bulkAddPointsModal.error(error && error.error
      ? error.error
      : (error && error.message ? error.message : 'Unable to load points for the selected classes.'));
  })
  .finally(function () {
    if (requestId === bulkAddPointsModal._discoveryRequest) {
      bulkAddPointsModal.loadingPoints(false);
      m.redraw();
    }
  });
}

function getCoverage() {
  return classPointSelection.buildCoverage(
    bulkAddPointsModal.pointGroups(),
    bulkAddPointsModal.selectedPointGroups(),
    getActiveEquipmentOptions()
  );
}

function buildSelectionPayload() {
  var activeEquipment = getActiveEquipmentOptions();
  return {
    equipmentClasses: (bulkAddPointsModal.selectedClasses() || []).slice(),
    equipmentScope: bulkAddPointsModal.equipmentScope(),
    selectedEquipmentRids: bulkAddPointsModal.equipmentScope() === 'selected'
      ? (bulkAddPointsModal.selectedEquipment() || []).slice()
      : [],
    snapshotEquipmentRids: activeEquipment.map(function (option) { return option.value; }),
    pointDefinitions: (bulkAddPointsModal.selectedPointGroups() || []).slice()
  };
}

function getExpandedSelection() {
  var selected = new Set(bulkAddPointsModal.selectedPointGroups() || []);
  var seen = new Set();
  var points = [];
  (bulkAddPointsModal.pointGroups() || []).forEach(function (group) {
    if (!group || !selected.has(group.value)) return;
    (group.points || []).forEach(function (point) {
      var key = point.pointRid + '|' + point.columnName;
      if (seen.has(key)) return;
      seen.add(key);
      points.push({ pointRid: point.pointRid, columnName: point.columnName });
    });
  });
  return points;
}

bulkAddPointsModal.editDialogue = function (reportRecord, dataset, options) {
  bulkAddPointsModal.reportRecord = reportRecord;
  bulkAddPointsModal.dataset = dataset;
  bulkAddPointsModal.onSaved = options && options.onSaved;
  bulkAddPointsModal.classOptions([]);
  var savedSelection = dataset && dataset.extendedProps && dataset.extendedProps.reportPointSelection;
  savedSelection = savedSelection && typeof savedSelection === 'object' ? savedSelection : null;
  bulkAddPointsModal.selectedClasses(savedSelection && Array.isArray(savedSelection.equipmentClasses)
    ? savedSelection.equipmentClasses.slice()
    : []);
  bulkAddPointsModal.discoveredDatasets([]);
  bulkAddPointsModal.equipmentOptions([]);
  bulkAddPointsModal.equipmentScope(savedSelection && savedSelection.equipmentScope === 'selected' ? 'selected' : 'all');
  bulkAddPointsModal.selectedEquipment(savedSelection && Array.isArray(savedSelection.selectedEquipmentRids)
    ? savedSelection.selectedEquipmentRids.slice()
    : []);
  bulkAddPointsModal.pointGroups([]);
  bulkAddPointsModal.selectedPointGroups(savedSelection && Array.isArray(savedSelection.pointDefinitions)
    ? savedSelection.pointDefinitions.slice()
    : []);
  bulkAddPointsModal.loadingClasses(false);
  bulkAddPointsModal.loadingPoints(false);
  bulkAddPointsModal.error('');
  bulkAddPointsModal._discoveryRequest += 1;
  bulkAddPointsModal._pendingSelection = savedSelection;

  modal.vm.title('Add points to ' + (dataset.name || 'worksheet'));
  modal.vm.body = bulkAddPointsModal;
  modal.vm.buttons([{
    label: 'Add selected points',
    func: function () {
      var points = getExpandedSelection();
      if (!points.length) {
        bulkAddPointsModal.error('Choose at least one point before saving.');
        m.redraw();
        return Promise.reject(new Error('Point selection is required.'));
      }
      if (points.length > MAX_POINTS_PER_ADD) {
        bulkAddPointsModal.error('This selection expands to more than ' + MAX_POINTS_PER_ADD + ' points. Choose fewer classes or point definitions.');
        m.redraw();
        return Promise.reject(new Error('Point selection is too large.'));
      }
      var reportRid = String(reportRecord['@rid']).replace(/^#/, '');
      return loaders.requestWithLoader({
        loader: 'submit',
        url: '/api/v1/report/' + reportRid + '/addPoints',
        method: 'PUT',
        body: {
          datasetRid: dataset['@rid'],
          points: points,
          selection: buildSelectionPayload()
        }
      })
      .then(function (updatedReport) {
        if (typeof bulkAddPointsModal.onSaved === 'function') {
          return Promise.resolve(bulkAddPointsModal.onSaved(updatedReport));
        }
      })
      .then(function () { modal.vm.close(); })
      .catch(function (error) {
        bulkAddPointsModal.error(error && error.error ? error.error : 'Could not add the selected points.');
        m.redraw();
        return Promise.reject(error);
      });
    }
  }]);
  modal.vm.open({ extrawidth: true });

  if (!normalizeLocationRid(reportRecord)) {
    bulkAddPointsModal.error('Choose a location for this report before adding points.');
    return Promise.resolve();
  }
  return loadClassOptions().then(function () {
    if (bulkAddPointsModal.selectedClasses().length) return loadPointsForClasses();
  });
};

function renderEquipmentScope(equipmentOptions) {
  var scope = bulkAddPointsModal.equipmentScope();
  var scopeButton = function (value, label) {
    var active = scope === value;
    return m('button.pa2.ph3.ba.br2.pointer.mr2.mb2', {
      type: 'button',
      class: active ? 'bg-blue white b--blue' : 'bg-dark-gray light-silver b--mid-gray',
      'aria-pressed': active ? 'true' : 'false',
      onclick: function () { selectEquipmentScope(value); }
    }, (active ? '✓ ' : '') + label);
  };
  return m('div.mb3', [
    m('label.db.mb1', 'Equipment scope'),
    m('div.flex.flex-wrap.items-center', [
      scopeButton('all', 'All matching equipment (' + equipmentOptions.length + ')'),
      scopeButton('selected', 'Choose equipment')
    ]),
    scope === 'selected'
      ? m('div.mt2', equipmentOptions.length
        ? m(choices, {
          data: equipmentOptions.map(function (option) { return { value: option.value, key: option.key }; }),
          value: selectedEquipmentChoices,
          placeholderValue: 'Select equipment'
        })
        : m('div.moon-gray', 'No matching equipment is available.'))
      : null
  ]);
}

function renderCoverage(coverage) {
  if (!coverage.pointDefinitionCount) return null;
  return m('div.pa3.ba.b--mid-gray.br2', [
    m('div.f5', 'Coverage review'),
    m('div.mt1', coverage.equipmentCount + ' equipment · ' + coverage.pointDefinitionCount + ' point definitions · ' + coverage.columnCount + ' fixed columns'),
    coverage.missingDefinitionCount
      ? m('div.mt2.gold', coverage.missingDefinitionCount + ' point definitions are not available on every selected equipment item.')
      : m('div.mt2.light-green', 'Every selected point definition is available on all selected equipment.'),
    m('div.overflow-auto.mt2', [
      m('table.w-100.collapse', [
        m('thead', m('tr.tl', [
          m('th.pv1.pr3', 'Point'),
          m('th.pv1.pr3.nowrap', 'Coverage'),
          m('th.pv1', 'Source point names')
        ])),
        m('tbody', coverage.rows.map(function (row) {
          var visibleMissing = row.missingEquipment.slice(0, 5);
          var remainingMissing = row.missingEquipment.length - visibleMissing.length;
          return m('tr.bt.b--mid-gray', [
            m('td.pv2.pr3', row.label),
            m('td.pv2.pr3' + (row.missingCount ? '.gold' : '.light-green'), [
              m('div.nowrap', row.matchedCount + ' / ' + row.totalCount + (row.missingCount ? ' (' + row.missingCount + ' missing)' : '')),
              row.missingCount
                ? m('div.f7.moon-gray.mt1', 'Missing: ' + visibleMissing.join(', ') + (remainingMissing > 0 ? ' +' + remainingMissing + ' more' : ''))
                : null
            ]),
            m('td.pv2.f6.moon-gray', row.sourcePointNames.length ? row.sourcePointNames.join(', ') : '—')
          ]);
        }))
      ])
    ]),
    m('div.f6.moon-gray.mt2', 'Saving adds a fixed point snapshot. Reopen this picker to review and deliberately add newly matched equipment later.')
  ]);
}

bulkAddPointsModal.view = function () {
  var locationRid = normalizeLocationRid(bulkAddPointsModal.reportRecord);
  var classOptions = bulkAddPointsModal.classOptions() || [];
  var equipmentOptions = bulkAddPointsModal.equipmentOptions() || [];
  var pointGroups = bulkAddPointsModal.pointGroups() || [];
  var activeEquipment = getActiveEquipmentOptions();
  var coverage = getCoverage();
  return m('form.form-dark', { role: 'form' }, [
    bulkAddPointsModal.error() ? m('div.red.mb3', bulkAddPointsModal.error()) : null,
    !locationRid ? null : [
      m('div.mb3', [
        m('label.db.mb1', 'Classes'),
        bulkAddPointsModal.loadingClasses()
          ? m('div.moon-gray', 'Loading classes…')
          : (classOptions.length
            ? m(choices, {
              data: classOptions,
              value: selectedClassChoices,
              placeholderValue: 'Select classes'
            })
            : m('div.moon-gray', 'No equipment classes are available.'))
      ]),
      bulkAddPointsModal.selectedClasses().length && !bulkAddPointsModal.loadingPoints()
        ? renderEquipmentScope(equipmentOptions)
        : null,
      m('div.mb3', [
        m('label.db.mb1', 'Points'),
        bulkAddPointsModal.loadingPoints()
          ? m('div.moon-gray', 'Loading points…')
          : (!bulkAddPointsModal.selectedClasses().length
            ? m('div.moon-gray', 'Select one or more equipment classes first.')
            : (!activeEquipment.length
              ? m('div.moon-gray', bulkAddPointsModal.equipmentScope() === 'selected'
                ? 'Choose one or more equipment items first.'
                : 'No matching equipment was found at this location.')
            : (pointGroups.length
              ? m(choices, {
                data: pointGroups.map(function (group) { return { value: group.value, key: group.key }; }),
                value: selectedPointChoices,
                placeholderValue: 'Select points'
              })
              : m('div.moon-gray', 'No points match the selected equipment.'))))
      ]),
      renderCoverage(coverage)
    ]
  ]);
};

bulkAddPointsModal.__testables = {
  getExpandedSelection: getExpandedSelection,
  getActiveEquipmentOptions: getActiveEquipmentOptions,
  getCoverage: getCoverage,
  buildSelectionPayload: buildSelectionPayload,
  normalizeLocationRid: normalizeLocationRid,
  selectedClassChoices: selectedClassChoices,
  selectedEquipmentChoices: selectedEquipmentChoices,
  selectedPointChoices: selectedPointChoices
};

module.exports = bulkAddPointsModal;
